import type { ReactNode } from "react";
import "@/style/sass/_contentVersionHistorySelect.scss";
import {
  formatContentVersionLabel,
  getCurrentContentVersionId,
  type ContentLanguageVersion,
} from "@/utils/contentVersionHistory";

type ContentVersionHistorySelectProps = {
  selectId: string;
  versions: ContentLanguageVersion[];
  value: number | null;
  onChange: (versionId: number | null) => void;
  disabled?: boolean;
  className?: string;
  label?: ReactNode;
};

export default function ContentVersionHistorySelect({
  selectId,
  versions,
  value,
  onChange,
  disabled = false,
  className = "",
  label,
}: ContentVersionHistorySelectProps) {
  if (!Array.isArray(versions) || versions.length === 0) {
    return null;
  }

  const currentVersionId = getCurrentContentVersionId(versions);
  const selectedValue = value ?? currentVersionId ?? "";
  const hasCustomLabel = label != null;

  return (
    <div className={`contentVersionHistorySelect ${className}`.trim()}>
      {hasCustomLabel ? (
        label
      ) : (
        <label htmlFor={selectId} className="contentVersionHistoryLabel">
          History
        </label>
      )}
      <select
        id={selectId}
        className="contentVersionHistoryDropdown"
        value={selectedValue}
        disabled={disabled}
        aria-label={hasCustomLabel ? "History" : undefined}
        onChange={(event) => {
          const nextValue = Number(event.target.value);
          if (!Number.isFinite(nextValue) || nextValue <= 0) {
            onChange(currentVersionId);
            return;
          }
          onChange(nextValue);
        }}
      >
        {versions.map((version, index) => (
          <option key={version.id} value={version.id}>
            {formatContentVersionLabel(version, index === 0)}
          </option>
        ))}
      </select>
    </div>
  );
}
